import $ from 'jquery';

$('.slick-testimonials').slick?.({
  dots: true,
  arrows: false,
  slidesToShow: 1,
  slidesToScroll: 1
});
